// Identity for every object in the universe (docs/ENGINEERING.md principle 5).
import { ulid } from "ulid";

export function newId(): string {
  return ulid();
}

/** Time (ms) an id was minted, recoverable from any ULID. */
export function idTime(id: string): number {
  const ENC = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
  let t = 0;
  for (let i = 0; i < 10; i++) t = t * 32 + ENC.indexOf(id[i]);
  return t;
}
